import {
    useMemo,
} from 'react'
import moment from 'moment'
import dateTimeStandardMask from 'app/utils/date/dateTimeStandardMask'

import useLabel from 'app/hooks/useLabel'
import InputSingleline from 'app/shared-components/InputSingleline'
import TemperatureInfo from 'app/shared-components/TemperatureInfo'

import useStyles from './TemperatureInfoLogger.style'

const bordersSensorAge = {
    new: 150,
    old: 180,
}

type Props = {
    logger?: {
        loggerNumber: string,
    },
    lastMeasured?: string,
    loggerExchanged?: string,
    temperature?: number,
}

const DEFAULT_LOGGER_DATA = {
    loggerNumber: '',
}

const TemperatureInfoLogger = ({
    logger: {
        loggerNumber,
    } = DEFAULT_LOGGER_DATA,
    loggerExchanged,
    lastMeasured,
    temperature,
}: Readonly<Props>) => {
    const l = useLabel()

    const sensorAge = loggerExchanged && moment().diff(moment(loggerExchanged, dateTimeStandardMask), 'days')

    const loggerExchangedValue = useMemo(() => {
        return loggerExchanged ? (
            `${l('EXCHANGED')} ${moment(loggerExchanged, dateTimeStandardMask).fromNow()}`
        ) : l('NO_DATA')
    }, [
        l,
        loggerExchanged,
    ])

    const {
        classes,
    } = useStyles()

    return (
        <div className={classes.wrapper}>
            <TemperatureInfo
                lastMeasured={lastMeasured}
                temperature={temperature}
            />
            <div className={classes.sensorInfo}>
                <div className={classes.sensorInfoItem}>
                    <InputSingleline
                        title={l('LOGGER')}
                        classNames={{
                            label: classes.label,
                        }}
                        value={loggerNumber}
                        name="loggerNumber"
                        disabled
                    />
                </div>
                <div className={classes.sensorInfoItem}>
                    <InputSingleline
                        title={l('LOGGER_AGE')}
                        classNames={
                            {
                                text: {
                                    [classes.new]: sensorAge <= bordersSensorAge.new,
                                    [classes.medium]: sensorAge > bordersSensorAge.new
                                        && sensorAge < bordersSensorAge.old,
                                    [classes.old]: sensorAge >= bordersSensorAge.old,
                                },
                                label: classes.label,
                            }
                        }
                        value={loggerExchangedValue}
                        name="loggerNumber"
                        disabled
                    />
                </div>
            </div>
        </div>
    )
}

export default TemperatureInfoLogger
